import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "actions-container" }
const _hoisted_3 = { class: "body-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_StatusTag = _resolveComponent("StatusTag")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_AttachmentModal = _resolveComponent("AttachmentModal")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!
  const _component_ModalCardConfirm = _resolveComponent("ModalCardConfirm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, [
      _createTextVNode(_toDisplayString(_ctx.$t('interventionRequest.singlePage.title')) + " " + _toDisplayString(this.$route.params.id) + " ", 1),
      _createVNode(_component_ReglePastille, { cle: "suiviDemandeInterventionDetail.actionsNonPlanifiee" }),
      _createVNode(_component_ReglePastille, { cle: "suiviDemandeInterventionDetail.rapportDisponible" })
    ]),
    _createVNode(_component_BorderedIconButton, {
      imgUrl: _ctx.imgUrl,
      onClick: this.$router.back,
      title: _ctx.$t('bouton.retour'),
      className: "back-btn"
    }, null, 8, ["imgUrl", "onClick", "title"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isNonPlanifiee)
        ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
            key: 0,
            imgUrl: _ctx.deleteImgUrl,
            onClick: _ctx.openDeleteModal,
            title: _ctx.$t('bouton.supprimer'),
            className: "btn-supprimer"
          }, null, 8, ["imgUrl", "onClick", "title"]))
        : _createCommentVNode("", true),
      (_ctx.isNonPlanifiee)
        ? (_openBlock(), _createBlock(_component_ButtonBlue, {
            key: 1,
            onClick: _ctx.sendReminder,
            text: _ctx.$t('dataList.relancer'),
            class: "btn-relance"
          }, null, 8, ["onClick", "text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.status !== null)
        ? (_openBlock(), _createBlock(_component_StatusTag, {
            key: 0,
            status: this.status
          }, null, 8, ["status"]))
        : _createCommentVNode("", true),
      (this.demandeInterventionData && this.isLoaded)
        ? (_openBlock(), _createBlock(_component_DataList, {
            key: 1,
            data: this.demandeInterventionData,
            "stop-propa-on-pdf": true,
            onDownloadPdf: _ctx.downloadPdf,
            onSelect: _ctx.goToPage
          }, null, 8, ["data", "onDownloadPdf", "onSelect"]))
        : _createCommentVNode("", true),
      (_ctx.attachment)
        ? (_openBlock(), _createBlock(_component_AttachmentModal, {
            key: 2,
            "content-type": _ctx.contentType,
            data: _ctx.attachment,
            onClose: _ctx.closeModal
          }, null, 8, ["content-type", "data", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.isAttachmentLoading)
        ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 3 }))
        : _createCommentVNode("", true),
      (_ctx.success)
        ? (_openBlock(), _createBlock(_component_SuccessModal, {
            key: 4,
            subtitle: _ctx.$t('intervention.success.reminder'),
            title: '',
            onCancel: _ctx.closeSuccess
          }, null, 8, ["subtitle", "onCancel"]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteSuccessModal)
        ? (_openBlock(), _createBlock(_component_SuccessModal, {
            key: 5,
            subtitle: _ctx.$t('intervention.request.delete.success', { id: this.$route.params.id }),
            title: '',
            onCancel: _ctx.closeDeleteSuccess
          }, null, 8, ["subtitle", "onCancel"]))
        : _createCommentVNode("", true),
      (_ctx.showDeleteModal)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 6,
            onCancel: _ctx.closeDeleteModal
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ModalCardConfirm, {
                activeValidate: true,
                headerTitle: _ctx.$t('intervention.deleteModal.title', { id: this.$route.params.id }),
                onCancel: _ctx.closeDeleteModal,
                onConfirm: _ctx.deleteDemande
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('intervention.request.deleteConfirm')), 1)
                ]),
                _: 1
              }, 8, ["headerTitle", "onCancel", "onConfirm"])
            ]),
            _: 1
          }, 8, ["onCancel"]))
        : _createCommentVNode("", true)
    ])
  ]))
}